import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBumper = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M76.126 21h11.747a7.11 7.11 0 0 1 7.126 7.126v45.747A7.11 7.11 0 0 1 87.873 81H12.126A7.11 7.11 0 0 1 5 73.873v-9.747c0-6.881-.867-22.207 18.083-33.044C42.022 20.252 64.663 21 76.127 21z" })
});
export default SvgBumper;
